import * as actions from "../../actions/marketing";

export interface MarketingState {
	items: any[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState = {
	items: [],
	item: null,
	name: "",
	users: [],
	startAt: null,
	economicMode: true,
	emailSubject: "",
	emailMessage: "",
	smsMessage: "",
	whatsAppMessage: "",
	whatsAppRestrict: true,
	pushAction: 0,
	pushValue: "",
	pushTitle: "",
	pushMessage: "",
	errors: {},
	loading: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_MARKETING: {
			return {
				...state,
				loading: { get: true },
				errors: initialState.errors
			};
		}
		case actions.GET_MARKETING_SUCCESS: {
			const newState = { ...state };

			if (payload) {
				newState.item = payload;
				newState.name = payload.name ?? initialState.name;
				newState.users =
					payload.users?.map((c: any) => ({ userId: c.userId })) ??
					initialState.users;
				newState.startAt = payload.startAt ?? initialState.startAt;
				newState.economicMode =
					payload.economicMode ?? initialState.economicMode;
				newState.emailSubject =
					payload.emailSubject ?? initialState.emailSubject;
				newState.emailMessage =
					payload.emailMessage ?? initialState.emailMessage;
				newState.smsMessage = payload.smsMessage ?? initialState.smsMessage;
				newState.whatsAppMessage =
					payload.whatsAppMessage ?? initialState.whatsAppMessage;
				newState.whatsAppRestrict =
					payload.whatsAppRestrict ?? initialState.whatsAppRestrict;
				newState.pushMessage = payload.pushMessage ?? initialState.pushMessage;
				newState.pushTitle = payload.pushTitle ?? initialState.pushTitle;
				newState.pushAction = payload.pushAction ?? initialState.pushAction;
				newState.pushValue = payload.pushValue ?? initialState.pushValue;
			} else {
				newState.item = null;
				newState.name = initialState.name;
				newState.users = initialState.users;
				newState.startAt = initialState.startAt;
				newState.economicMode = initialState.economicMode;
				newState.emailSubject = initialState.emailSubject;
				newState.emailMessage = initialState.emailMessage;
				newState.smsMessage = initialState.smsMessage;
				newState.whatsAppMessage = initialState.whatsAppMessage;
				newState.whatsAppRestrict = initialState.whatsAppRestrict;
				newState.pushMessage = initialState.pushMessage;
				newState.pushTitle = initialState.pushTitle;
				newState.pushAction = initialState.pushAction;
				newState.pushValue = initialState.pushValue;
			}

			return {
				...newState,
				loading: { get: false }
			};
		}
		case actions.GET_MARKETING_FAILED: {
			return {
				...state,
				loading: { get: false },
				errors: payload
			};
		}
		case actions.GET_MARKETINGS: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_MARKETINGS_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_MARKETINGS_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.CREATE_MARKETING: {
			return {
				...state,
				loading: { create: true },
				errors: initialState.errors
			};
		}
		case actions.CREATE_MARKETING_SUCCESS: {
			return {
				...state,
				loading: { create: false },
				items: [payload, ...state.items],
				item: null,
				name: initialState.name,
				users: initialState.users,
				startAt: initialState.startAt,
				economicMode: initialState.economicMode,
				emailSubject: initialState.emailSubject,
				emailMessage: initialState.emailMessage,
				smsMessage: initialState.smsMessage,
				whatsAppMessage: initialState.whatsAppMessage,
				whatsAppRestrict: initialState.whatsAppRestrict,
				pushTitle: initialState.pushTitle,
				pushMessage: initialState.pushMessage,
				pushAction: initialState.pushAction,
				pushValue: initialState.pushValue
			};
		}
		case actions.CREATE_MARKETING_FAILED: {
			return {
				...state,
				loading: { create: false },
				errors: payload
			};
		}
		case actions.UPDATE_MARKETING: {
			return {
				...state,
				loading: { update: true },
				errors: initialState.errors
			};
		}
		case actions.UPDATE_MARKETING_SUCCESS: {
			const items = state.items.filter((c: any) => c.id !== payload.id);

			items.unshift(payload as never);

			return {
				...state,
				loading: { update: false },
				item: null,
				items,
				name: initialState.name,
				users: initialState.users,
				startAt: initialState.startAt,
				economicMode: initialState.economicMode,
				emailSubject: initialState.emailSubject,
				emailMessage: initialState.emailMessage,
				smsMessage: initialState.smsMessage,
				whatsAppMessage: initialState.whatsAppMessage,
				whatsAppRestrict: initialState.whatsAppRestrict,
				pushTitle: initialState.pushTitle,
				pushMessage: initialState.pushMessage,
				pushAction: initialState.pushAction,
				pushValue: initialState.pushValue
			};
		}
		case actions.UPDATE_MARKETING_FAILED: {
			return {
				...state,
				loading: { update: false },
				errors: payload
			};
		}
		case actions.RESEND_MARKETING: {
			return {
				...state,
				loading: { resend: true },
				errors: initialState.errors
			};
		}
		case actions.RESEND_MARKETING_SUCCESS: {
			return {
				...state,
				loading: { resend: false }
			};
		}
		case actions.RESEND_MARKETING_FAILED: {
			return {
				...state,
				loading: { resend: false },
				errors: payload
			};
		}
		case actions.SET_VALUE: {
			return {
				...state,
				...payload
			};
		}
		case actions.CLEAR_VALUES: {
			if (payload) return { ...initialState };

			return {
				...state,
				item: null,
				name: initialState.name,
				users: initialState.users,
				startAt: initialState.startAt,
				economicMode: initialState.economicMode,
				emailSubject: initialState.emailSubject,
				emailMessage: initialState.emailMessage,
				smsMessage: initialState.smsMessage,
				whatsAppMessage: initialState.whatsAppMessage,
				whatsAppRestrict: initialState.whatsAppRestrict,
				pushTitle: initialState.pushTitle,
				pushMessage: initialState.pushMessage,
				pushAction: initialState.pushAction,
				pushValue: initialState.pushValue
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
